var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"flix-btn flix-btn-save",attrs:{"href":"#"},domProps:{"innerHTML":_vm._s(_vm.title)},on:{"click":function($event){$event.preventDefault();return _vm.setSave.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }